import { useEffect } from "react"
import { UserConsent } from "cookiesConsent/domain/consent"
import { GtmConsentSignalFactory } from "cookiesConsent/infrastructure/gtm/GtmConsentSignal"
import { googleTag } from "cookiesConsent/infrastructure/gtm/GoogleTag"

interface PublishConsentToGtmProps {
  consent: UserConsent
}

const PublishConsentToGtm = ({ consent }: PublishConsentToGtmProps) => {
  useEffect(() => {
    googleTag.updateConsent(new GtmConsentSignalFactory().fromConsent(consent))
  }, [consent])

  return null
}

export default PublishConsentToGtm
